//
//  CustomAuthUI.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import {
  GoogleSignInButton,
  MicrosoftSignInButton,
} from "./CustomSignInButton";
import { AUTH_TYPE, AuthType } from "../utils/env";

export interface CustomAuthUIProps {
  handleSignIn: () => void;
  error: string | null;
}

export const CustomAuthUI: React.FC<CustomAuthUIProps> = ({
  handleSignIn,
  error,
}) => {
  return (
    <div
      style={{
        maxWidth: 320,
        margin: "0 auto",
        padding: 24,
        border: "1px solid #eee",
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}
    >
      {AUTH_TYPE === AuthType.Google && (
        <GoogleSignInButton onClick={handleSignIn} />
      )}
      {AUTH_TYPE === AuthType.Microsoft && (
        <MicrosoftSignInButton onClick={handleSignIn} />
      )}
      {error && <div style={{ color: "red", marginTop: 16 }}>{error}</div>}
    </div>
  );
};
